function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { isEqual, isEmpty, get, some, values, intersectionBy, compact } from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@unite-us/app-components';
import { setData, useAppCreateReferralContext } from '../../context/AppCreateReferralProvider';
import StepHeader from '../../components/StepHeader';
import ReferralCard from './ReferralCard';
import ReferralBuilderForm from './ReferralBuilderForm';
import { isUnlistedProgram, getReferralSubtitle, initializeReferralErrors, generateErrorMessage, hasOffPlatformReferrals, isEmptyErrors, removeErrorByIndex, updatedReferralsBySelectedServices } from './utils';
import useBuildReferrals from './useBuildReferrals';
import CreateReferralContainer from '../../components/CreateReferralContainer';
import NavButtons from '../../components/NavButtons';
import NoReferralsDisplay from './NoReferralsDisplay';
import { removeReferralProgram } from '../../actions/Referral/removeReferralProgram';
import Spinner from '../../components/spinners/Spinner';
import useCreateReferrals from '../../hooks/useCreateReferrals';
import { CALLBACKS } from '../../api/config';
import fetchContactDocuments from '../../actions/Document/Contact/Group/fetchContactDocuments';
import fetchCaseDocuments from '../../actions/Document/Contact/Group/fetchCaseDocuments';
import classNames from 'classnames';
import fetchNetworks from '../../actions/Referral/fetchNetworks';
import { useFeatureFlag } from '../../utils/useFeatureFlag';
import ChooseOneServiceTypeModal from './ChooseOneServiceTypeModal';
import { REFERRAL_BUILDER_DESCRIPTION } from './constants';
import { handleKeyDown } from '../../common/utils/utils';
import AboutGroupedReferralsModal from './AboutGroupedReferralsModal';
export default function ReferralBuilder() {
  var _location$state$selec, _location$state;
  var location = useLocation();
  var navigate = useNavigate();
  var _useAppCreateReferral = useAppCreateReferralContext(),
    dispatch = _useAppCreateReferral.dispatch,
    _useAppCreateReferral2 = _useAppCreateReferral.state,
    referrals = _useAppCreateReferral2.referrals,
    selectedPrograms = _useAppCreateReferral2.selectedPrograms,
    currentEmployee = _useAppCreateReferral2.currentEmployee,
    currentProvider = _useAppCreateReferral2.currentProvider,
    fieldsConfig = _useAppCreateReferral2.fieldsConfig,
    source = _useAppCreateReferral2.source,
    person = _useAppCreateReferral2.person,
    draftState = _useAppCreateReferral2.draftState,
    referralDescription = _useAppCreateReferral2.referralDescription,
    caseId = _useAppCreateReferral2.caseId,
    referralId = _useAppCreateReferral2.referralId,
    referralType = _useAppCreateReferral2.referralType;
  var form = useRef();
  var ChooseOneServiceTypeModalRef = useRef();
  var openChooseOneServiceTypeModal = useCallback(function () {
    ChooseOneServiceTypeModalRef.current.openDialog();
  }, []);
  var closeChooseOneServiceTypeModal = useCallback(function () {
    ChooseOneServiceTypeModalRef.current.closeDialog();
  }, []);
  var hint542SupersetUnlistedPrograms = useFeatureFlag('hint542SupersetUnlistedPrograms', false);
  var crtb1239AdaptDraftReferralFlow = useFeatureFlag('crtb1239AdaptDraftReferralFlow', false);
  var pays3551AuthInSuperset = useFeatureFlag('pays3551AuthInSuperset', false);
  var crtb1299HighRejectionSolution = useFeatureFlag('crtb1299HighRejectionSolution', false);
  var showOpenedDate = useFeatureFlag('crtb824AddOpenCloseDateOffPlatformCase', false);
  var crtb854ForwardingSuperset = useFeatureFlag('crtb854ForwardingSuperset', false);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    servicesState = _useState2[0],
    setServicesState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    aboutGroupedReferralsModalIsOpen = _useState4[0],
    setAboutGroupedReferralsModalIsOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpenChooseOneServiceTypeModal = _useState6[0],
    setChooseOneServiceTypeModalIsOpen = _useState6[1];
  var _useState7 = useState((_location$state$selec = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.selectedReferral) !== null && _location$state$selec !== void 0 ? _location$state$selec : 0),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedIndex = _useState8[0],
    setSelectedIndex = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    fieldErrors = _useState10[0],
    setFieldErrors = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    nextClicked = _useState12[0],
    setNextClicked = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    saveDraftClicked = _useState14[0],
    setSaveDraftClicked = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    expandReferralsCard = _useState16[0],
    setExpandReferralsCard = _useState16[1];
  var _useState17 = useState(window.innerWidth),
    _useState18 = _slicedToArray(_useState17, 2),
    width = _useState18[0],
    setWidth = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    documents = _useState20[0],
    setDocuments = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    caseDocuments = _useState22[0],
    setCaseDocuments = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    loadedDocuments = _useState24[0],
    setloadedDocuments = _useState24[1];
  var isEmrSource = source === 'emr';
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    networksUnlistedProgram = _useState26[0],
    setNetworksUnlistedProgram = _useState26[1];
  var hasDraftReferral = (draftState === null || draftState === void 0 ? void 0 : draftState.state) === 'draft';
  var referralBuilderTitle = crtb1239AdaptDraftReferralFlow && hasDraftReferral ? 'Edit Your Referrals' : 'Prepare Your Referrals';
  var isWindowsSizeLarge = width > (isEmrSource ? 800 : 1200);
  var isForwardReferralPath = !!referralId && !!referralType;
  var errors = Object.keys(fieldErrors).reduce(function (acc, index) {
    var fieldError = fieldErrors[index];
    acc[index] = {
      service: fieldError === null || fieldError === void 0 ? void 0 : fieldError.service,
      network: fieldError === null || fieldError === void 0 ? void 0 : fieldError.network,
      primary_worker: fieldError === null || fieldError === void 0 ? void 0 : fieldError.primary_worker,
      description: fieldError === null || fieldError === void 0 ? void 0 : fieldError.description,
      amount_requested: (fieldError === null || fieldError === void 0 ? void 0 : fieldError.amount_requested) || (fieldError === null || fieldError === void 0 ? void 0 : fieldError.amount_exceeded),
      service_end: (fieldError === null || fieldError === void 0 ? void 0 : fieldError.service_end) || (fieldError === null || fieldError === void 0 ? void 0 : fieldError.invalid_insurance_auth_dates),
      passthrough_dates: fieldError === null || fieldError === void 0 ? void 0 : fieldError.passthrough_dates,
      opened_date: fieldError === null || fieldError === void 0 ? void 0 : fieldError.opened_date,
      icd10_code: fieldError === null || fieldError === void 0 ? void 0 : fieldError.icd10_code
    };
    return acc;
  }, {});
  var setReferralErrors = function setReferralErrors(referralIndex, newErrors) {
    setFieldErrors(function (prevFieldErrors) {
      var currentErrors = prevFieldErrors[referralIndex];
      var updatedErrors = _objectSpread(_objectSpread({}, currentErrors), newErrors);
      if (isEqual(updatedErrors, currentErrors)) {
        return prevFieldErrors;
      }
      return _objectSpread(_objectSpread({}, prevFieldErrors), {}, _defineProperty({}, referralIndex, updatedErrors));
    });
  };
  var onReferralsBuilt = function onReferralsBuilt(groupedReferrals) {
    if (!isEmpty(groupedReferrals)) {
      var initErrors = initializeReferralErrors(groupedReferrals, pays3551AuthInSuperset, showOpenedDate);
      groupedReferrals.forEach(function (_referral, index) {
        setReferralErrors(index, initErrors[index]);
      });
    }
  };
  var _useBuildReferrals = useBuildReferrals(onReferralsBuilt),
    isLoading = _useBuildReferrals.isLoading;
  var handleServiceSelectionChange = function handleServiceSelectionChange(programId, serviceId) {
    setServicesState(function (prevState) {
      return prevState.map(function (service) {
        return service.programId === programId && service.serviceId === serviceId ? _objectSpread(_objectSpread({}, service), {}, {
          selected: !service.selected
        }) : service;
      });
    });
  };
  var findServiceName = function findServiceName(_ref) {
    var _referralThatHasTheSe;
    var serviceToFind = _ref.serviceToFind;
    var referralThatHasTheService = referrals === null || referrals === void 0 ? void 0 : referrals.find(function (referral) {
      var _referral$service;
      return (referral === null || referral === void 0 || (_referral$service = referral.service) === null || _referral$service === void 0 ? void 0 : _referral$service.id) === serviceToFind;
    });
    return referralThatHasTheService === null || referralThatHasTheService === void 0 || (_referralThatHasTheSe = referralThatHasTheService.service) === null || _referralThatHasTheSe === void 0 ? void 0 : _referralThatHasTheSe.name;
  };
  var mapProgramsToServicesState = function mapProgramsToServicesState() {
    return selectedPrograms.flatMap(function (program) {
      return program.services.map(function (serviceToFind) {
        var serviceName = findServiceName({
          serviceToFind: serviceToFind
        });
        return {
          programId: program.id,
          serviceId: serviceToFind,
          serviceName: serviceName,
          selected: program.services.length === 1
        };
      });
    });
  };
  useEffect(function () {
    if (crtb1299HighRejectionSolution) {
      var initialState = mapProgramsToServicesState();
      setServicesState(initialState);
    }
  }, [selectedPrograms]);
  useEffect(function () {
    if (!isLoading && hint542SupersetUnlistedPrograms) {
      // If the selected programs contain unlisted programs, fetch the networks from the user provider
      var hasUnlistedPrograms = selectedPrograms === null || selectedPrograms === void 0 ? void 0 : selectedPrograms.some(function (program) {
        return isUnlistedProgram(program);
      });
      if (hasUnlistedPrograms) {
        fetchNetworks(currentProvider).then(function (networks) {
          setNetworksUnlistedProgram(networks);
        });
      }
    }
  }, [isLoading]);
  useEffect(function () {
    var handleResize = function handleResize() {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [width]);
  useEffect(function () {
    isWindowsSizeLarge && handleExpandReferralsCard();
  }, [width]);
  var handleExpandReferralsCard = function handleExpandReferralsCard() {
    if (expandReferralsCard) {
      changeWidthReferralCard();
    }
  };
  var onLearnMoreClick = function onLearnMoreClick() {
    setAboutGroupedReferralsModalIsOpen(true);
  };
  var onCloseGroupedReferralsModal = function onCloseGroupedReferralsModal() {
    setAboutGroupedReferralsModalIsOpen(false);
  };
  var refModal = useRef(null);
  useEffect(function () {
    if (aboutGroupedReferralsModalIsOpen) {
      refModal.current.openModal();
    } else {
      refModal.current.closeModal();
    }
  }, [aboutGroupedReferralsModalIsOpen]);
  useEffect(function () {
    if (crtb1299HighRejectionSolution && !isLoading && isOpenChooseOneServiceTypeModal) {
      openChooseOneServiceTypeModal();
    }
  }, [isLoading]);
  var onReferralCardClick = function onReferralCardClick(index) {
    setSelectedIndex(index);
  };
  useEffect(function () {
    fetchContactDocuments(person.id).then(function (result) {
      setDocuments(result);
    });
  }, []);
  useEffect(function () {
    if (caseId && crtb854ForwardingSuperset) {
      fetchCaseDocuments(caseId).then(function (result) {
        setCaseDocuments(result);
      });
    }
  }, []);
  useEffect(function () {
    if (!isEmpty(referrals) && !loadedDocuments && (!isEmpty(documents) || !isEmpty(caseDocuments))) {
      var updatedReferrals = referrals.map(function (referral) {
        if (!referral.attachableDocuments) {
          return _objectSpread(_objectSpread({}, referral), {}, {
            attachableDocuments: [].concat(_toConsumableArray(documents), _toConsumableArray(caseDocuments)).map(function (doc) {
              return {
                attached: false,
                document: doc
              };
            })
          });
        } else {
          return referral;
        }
      });
      dispatch(setData({
        referrals: updatedReferrals
      }));
      setloadedDocuments(true);
    }
    if (crtb1299HighRejectionSolution) {
      var hasMoreThanOneServiceType = selectedPrograms.some(function (program) {
        var _program$services;
        return (program === null || program === void 0 || (_program$services = program.services) === null || _program$services === void 0 ? void 0 : _program$services.length) > 1;
      });
      setChooseOneServiceTypeModalIsOpen(hasMoreThanOneServiceType);
    }
  }, [referrals]);
  var getSelected = function getSelected() {
    return referrals && referrals[selectedIndex];
  };
  var saveValuesOnChange = function saveValuesOnChange(props) {
    var values = props.values;
    var updatedReferrals = referrals;
    updatedReferrals[selectedIndex] = _objectSpread({}, values);

    // Testing: Avoid React Final Form error: FormSpy Cannot update a component while rendering
    // https://github.com/final-form/react-final-form/issues/809#issue-638963034
    setTimeout(function () {
      return dispatch(setData({
        referrals: _toConsumableArray(updatedReferrals)
      }));
    }, 0);
  };
  var firstIndexWithErrors = Object.entries(errors).findIndex(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      _index = _ref3[0],
      values = _ref3[1];
    return Object.values(values).some(Boolean);
  });
  var focusErrors = function focusErrors() {
    var index = selectedIndex;
    if (!some(values(errors[index]), Boolean)) {
      index = firstIndexWithErrors;
      setSelectedIndex(index);
    }
    setFocus(index);
  };
  var onNextClick = function onNextClick() {
    if (isEmptyErrors(errors)) {
      return navigate("/create/".concat(isForwardReferralPath ? 'review' : 'supporting-info'));
    }
    focusErrors();
    setNextClicked(true);
  };
  var setFocus = function setFocus(index) {
    setTimeout(function () {
      var _errors$index, _errors$index2, _errors$index3, _errors$index4, _errors$index5, _errors$index6, _errors$index7;
      if ((_errors$index = errors[index]) !== null && _errors$index !== void 0 && _errors$index.network) {
        var _form$current;
        (_form$current = form.current) === null || _form$current === void 0 || (_form$current = _form$current.mutators) === null || _form$current === void 0 || _form$current.setFieldTouched('network', true);
        var networkField = document.getElementById("network-selection").parentElement.parentElement;
        return networkField.focus();
      }
      if ((_errors$index2 = errors[index]) !== null && _errors$index2 !== void 0 && _errors$index2.amount_requested) {
        var _form$current2;
        (_form$current2 = form.current) === null || _form$current2 === void 0 || (_form$current2 = _form$current2.mutators) === null || _form$current2 === void 0 || _form$current2.setFieldTouched('paymentAuthForm.amount_requested', true);
        var amountRequested = document.getElementById("authorization-request-amount-requested");
        return amountRequested.focus();
      }
      if ((_errors$index3 = errors[index]) !== null && _errors$index3 !== void 0 && _errors$index3.service_end || (_errors$index4 = errors[index]) !== null && _errors$index4 !== void 0 && _errors$index4.passthrough_dates) {
        var _form$current3;
        (_form$current3 = form.current) === null || _form$current3 === void 0 || (_form$current3 = _form$current3.mutators) === null || _form$current3 === void 0 || _form$current3.setFieldTouched('paymentAuthForm.service_end', true);
        var selectDatesButton = document.getElementById("authorization-request-service-dates");
        return selectDatesButton.focus();
      }
      if ((_errors$index5 = errors[index]) !== null && _errors$index5 !== void 0 && _errors$index5.icd10_code) {
        var _form$current4;
        (_form$current4 = form.current) === null || _form$current4 === void 0 || (_form$current4 = _form$current4.mutators) === null || _form$current4 === void 0 || _form$current4.setFieldTouched('paymentAuthForm.icd10_code', true);
        var icd10CodeField = document.getElementById("authorization-request-icd10-code");
        return icd10CodeField.focus();
      }
      if ((_errors$index6 = errors[index]) !== null && _errors$index6 !== void 0 && _errors$index6.description) {
        var _form$current5;
        (_form$current5 = form.current) === null || _form$current5 === void 0 || (_form$current5 = _form$current5.mutators) === null || _form$current5 === void 0 || _form$current5.setFieldTouched('description', true);
        var descriptionField = document.getElementById("referral-description");
        return descriptionField.focus();
      }
      if ((_errors$index7 = errors[index]) !== null && _errors$index7 !== void 0 && _errors$index7.primary_worker) {
        var _form$current6;
        (_form$current6 = form.current) === null || _form$current6 === void 0 || (_form$current6 = _form$current6.mutators) === null || _form$current6 === void 0 || _form$current6.setFieldTouched('primaryWorker', true);
        var primaryWorkerField = document.getElementById("primary-worker").parentElement.parentElement;
        return primaryWorkerField.focus();
      }
    }, 100);
  };
  var moveToExistingReferral = function moveToExistingReferral(index, program) {
    var programs = referrals[selectedIndex].programs;
    referrals[selectedIndex] = _objectSpread(_objectSpread({}, referrals[selectedIndex]), {}, {
      programs: programs.filter(function (p) {
        return p.id !== program.id;
      })
    });
    if (isEmpty(referrals[selectedIndex].programs)) {
      referrals[selectedIndex] = null;
    }
    referrals[index] = _objectSpread(_objectSpread({}, referrals[index]), {}, {
      programs: [].concat(_toConsumableArray(referrals[index].programs), [program])
    });
    var newErrors = removeErrorByIndex(errors, selectedIndex);
    setFieldErrors(newErrors);
    dispatch(setData({
      referrals: compact(referrals)
    }));
    var newIndex = selectedIndex < index ? index - 1 : index;
    setSelectedIndex(newIndex);
  };
  var moveToNewReferral = function moveToNewReferral(program) {
    var referral = referrals[selectedIndex];
    referral.programs = referral.programs.filter(function (p) {
      return p.id !== program.id;
    });
    var newReferral = _objectSpread(_objectSpread({}, referral), {}, {
      programs: [program],
      description: ''
    });
    var newReferrals = [].concat(_toConsumableArray(referrals), [newReferral]);
    dispatch(setData({
      referrals: newReferrals
    }));
    setSelectedIndex(newReferrals.length - 1);
  };
  var removeProgram = function removeProgram(programId, serviceId) {
    var referral = referrals[selectedIndex];
    var newReferral = removeReferralProgram({
      referral: referral,
      programId: programId,
      serviceId: serviceId
    });
    referrals[selectedIndex] = newReferral ? _objectSpread({}, newReferral) : null;
    var newReferrals = compact(referrals);
    var newReferralPrograms = newReferrals.flatMap(function (r) {
      return r.programs;
    });
    var newSelectedPrograms = intersectionBy(selectedPrograms, newReferralPrograms, 'id');
    dispatch(setData({
      referrals: _toConsumableArray(newReferrals),
      selectedPrograms: _toConsumableArray(newSelectedPrograms)
    }));
    if (!referrals[selectedIndex]) {
      var newErrors = removeErrorByIndex(errors, selectedIndex);
      setFieldErrors(newErrors);
      setSelectedIndex(0);
    }
  };
  var updateAttachments = function updateAttachments(attachments) {
    referrals[selectedIndex] = _objectSpread(_objectSpread({}, referrals[selectedIndex]), {}, {
      attachments: attachments
    });
    dispatch(setData({
      referrals: referrals
    }));
  };
  var navigateBack = function navigateBack() {
    if (CALLBACKS.onNavigateBack) {
      CALLBACKS.onNavigateBack(crtb854ForwardingSuperset ? {
        referralId: referralId,
        referralDescription: referralDescription
      } : {
        referralDescription: referralDescription
      });
    } else {
      navigate(-1);
    }
  };
  var navigateToAddResources = function navigateToAddResources() {
    return CALLBACKS.onNavigateToAddResources();
  };
  var createReferrals = useCreateReferrals();
  var handleSaveDraftReferral = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var onSaveDraftReferral;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setSaveDraftClicked(true);
            if (!isEmptyErrors(errors)) {
              _context.next = 9;
              break;
            }
            _context.next = 4;
            return createReferrals({
              draft: true
            });
          case 4:
            onSaveDraftReferral = CALLBACKS.onSaveDraftReferral;
            onSaveDraftReferral && onSaveDraftReferral();
            CALLBACKS.notify.success('Draft referral successfully saved');
            _context.next = 10;
            break;
          case 9:
            focusErrors();
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSaveDraftReferral() {
      return _ref4.apply(this, arguments);
    };
  }();
  var changeWidthReferralCard = function changeWidthReferralCard() {
    setExpandReferralsCard(!expandReferralsCard);
  };
  var showMargin = function showMargin() {
    return isWindowsSizeLarge && !isEmrSource ? 'mr-5 ' : ' ';
  };
  if (isLoading) return /*#__PURE__*/React.createElement(Spinner, {
    center: true
  });
  var referralSubtitle = getReferralSubtitle(referrals, getSelected());
  var unselectedReferralIndexes = referrals.map(function (_referral, index) {
    return index;
  }).filter(function (index) {
    return index !== selectedIndex;
  });
  var allPrograms = referrals === null || referrals === void 0 ? void 0 : referrals.flatMap(function (r) {
    return r.programs;
  });
  var errorMessage = generateErrorMessage(errors);
  var currentReferral = getSelected();
  var xlOrLgInvisibleChevron = classNames({
    'lg:invisible': isEmrSource,
    'xl:invisible': !isEmrSource
  });
  var xlOrLgSpaceReferralDiv = classNames({
    'lg:space-x-6': isEmrSource,
    'lg:space-x-0 xl:space-x-6': !isEmrSource
  });
  var onConfirmApplyChanges = function onConfirmApplyChanges() {
    var filteredSelectedServices = servicesState.filter(function (service) {
      return service.selected;
    });
    var filteredNonSelectedServices = servicesState.filter(function (service) {
      return !service.selected;
    });
    var updatedReferrals = updatedReferralsBySelectedServices(referrals, filteredSelectedServices);
    var initErrors = initializeReferralErrors(updatedReferrals, pays3551AuthInSuperset, showOpenedDate);
    setFieldErrors(initErrors);
    dispatch(setData({
      referrals: updatedReferrals
    }));
    filteredNonSelectedServices.forEach(function (service) {
      CALLBACKS.onDeselectProgram({
        id: service.programId,
        service: service.serviceId
      });
    });
    closeChooseOneServiceTypeModal();
  };
  return /*#__PURE__*/React.createElement(CreateReferralContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "px-12"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    header: referralBuilderTitle
  }, REFERRAL_BUILDER_DESCRIPTION, /*#__PURE__*/React.createElement("button", {
    className: "text-text-blue",
    type: "button",
    onClick: onLearnMoreClick,
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, onLearnMoreClick);
    },
    "aria-expanded": aboutGroupedReferralsModalIsOpen
  }, "Learn more about referrals.")), /*#__PURE__*/React.createElement(AboutGroupedReferralsModal, {
    ref: refModal,
    onClose: onCloseGroupedReferralsModal
  }), crtb1299HighRejectionSolution && isOpenChooseOneServiceTypeModal && /*#__PURE__*/React.createElement(ChooseOneServiceTypeModal, {
    closeDialog: closeChooseOneServiceTypeModal,
    programs: selectedPrograms,
    referrals: referrals,
    modalRef: ChooseOneServiceTypeModalRef,
    findServiceName: findServiceName,
    onConfirm: onConfirmApplyChanges,
    onServiceSelectionChange: handleServiceSelectionChange,
    servicesState: servicesState
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavButtons, {
    onBackClick: navigateBack,
    onForwardClick: onNextClick,
    onSaveDraftReferral: handleSaveDraftReferral,
    primaryLabel: "Next",
    hideForwardButtons: isEmpty(referrals),
    hideSaveDraftLink: get(fieldsConfig, 'hideSaveDraftLink'),
    hasOffPlatformReferrals: hasOffPlatformReferrals(referrals),
    hasDraftReferral: hasDraftReferral,
    crtb1239AdaptDraftReferralFlow: crtb1239AdaptDraftReferralFlow,
    isForwardReferralPath: isForwardReferralPath
  }), !isEmpty(allPrograms) ? /*#__PURE__*/React.createElement("div", {
    className: "relative mx-auto responsive-max-width"
  }, errorMessage && (nextClicked || saveDraftClicked) ? /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "InfoCircle",
    color: "red",
    className: "mr-2 mt-px"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-red"
  }, errorMessage)) : null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end my-5 ".concat(xlOrLgSpaceReferralDiv)
  }, /*#__PURE__*/React.createElement("div", {
    id: "referrals-card",
    className: "bg-white border border-solid border-blue-border rounded ".concat(showMargin(), "\n                    ").concat(expandReferralsCard ? 'relative md:max-w-none lg:w-3/6 z-20' : 'md:w-2/6 lg:w-2/6')
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-5 h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between relative"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "text-xl font-black mb-5"
  }, "Referrals")), /*#__PURE__*/React.createElement("div", {
    className: xlOrLgInvisibleChevron
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "ChevronArrow",
    direction: expandReferralsCard ? "left" : "right",
    ariaLabel: expandReferralsCard ? "Collapse sidebar" : "Expand Sidebar",
    className: "w-6 h-6",
    onClick: function onClick() {
      return changeWidthReferralCard();
    }
  }))), referrals === null || referrals === void 0 ? void 0 : referrals.map(function (referral, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-5",
      key: "referral-card-".concat(index, "-wrapper")
    }, /*#__PURE__*/React.createElement(ReferralCard, {
      referral: referral,
      index: index,
      selectedIndex: selectedIndex,
      onClick: onReferralCardClick,
      errors: errors[index],
      expandReferralsCard: expandReferralsCard,
      isEmrSource: isEmrSource
    }));
  }))), !isEmpty(get(currentReferral, 'programs', [])) ? /*#__PURE__*/React.createElement(ReferralBuilderForm, {
    crtb1239AdaptDraftReferralFlow: crtb1239AdaptDraftReferralFlow,
    currentEmployee: currentEmployee,
    currentProvider: currentProvider,
    hasDraftReferral: hasDraftReferral,
    navigateToAddResources: navigateToAddResources,
    referral: currentReferral,
    referrals: referrals,
    referralSubtitle: referralSubtitle,
    index: selectedIndex,
    onChange: saveValuesOnChange,
    unselected: unselectedReferralIndexes,
    removeProgram: removeProgram,
    onSetForm: function onSetForm(newForm) {
      form.current = newForm;
    },
    moveToNewReferral: moveToNewReferral,
    moveToExistingReferral: moveToExistingReferral,
    updateAttachments: updateAttachments,
    source: source,
    networksUnlistedProgram: networksUnlistedProgram,
    setReferralErrors: setReferralErrors,
    referralDescription: referralDescription,
    expandReferralsCard: expandReferralsCard
  }) : null)) : /*#__PURE__*/React.createElement(NoReferralsDisplay, {
    crtb1239AdaptDraftReferralFlow: crtb1239AdaptDraftReferralFlow,
    hasDraftReferral: hasDraftReferral,
    navigateToAddResources: navigateToAddResources,
    onClick: navigateBack
  }), /*#__PURE__*/React.createElement(NavButtons, {
    onBackClick: navigateBack,
    onForwardClick: onNextClick,
    onSaveDraftReferral: handleSaveDraftReferral,
    primaryLabel: "Next",
    hideForwardButtons: isEmpty(referrals),
    hideSaveDraftLink: get(fieldsConfig, 'hideSaveDraftLink'),
    hasDraftReferral: hasDraftReferral,
    hasOffPlatformReferrals: hasOffPlatformReferrals(referrals),
    crtb1239AdaptDraftReferralFlow: crtb1239AdaptDraftReferralFlow,
    isForwardReferralPath: isForwardReferralPath
  }))));
}
//# sourceMappingURL=ReferralBuilder.js.map